export default "__VITE_ASSET__DfglkkCW__"